export const TIME_PER_QUESTION_IN_SECONDS = 60;
export const DANGER_TIME_LEFT_IN_SECONDS = 10;
